import { Briefcase } from '@finect/tabular-icons/briefcase';
import { User } from '@finect/tabular-icons/user';
import { Mail } from '@finect/tabular-icons/mail';
import { Heart } from '@finect/tabular-icons/heart';
import { Settings } from '@finect/tabular-icons/settings';
import { PieChart } from '@finect/tabular-icons/pieChart';
import { LogOut } from '@finect/tabular-icons/logOut';
import { Activity } from '@finect/tabular-icons/activity';
import { getLoginBaseURL } from '@finect/front-utils/getLoginBaseURL';
import { getBlobAction } from './utils';
export const UMBRELLA_TAG = 'main-nav';
export const BANK_TAG = 34491;
export const PORTAL_SECTION_MAX_STOREFRONTS = 6;
export const PORTAL_SECTION_MAX_BANKS = 6;
export const PORTAL_SECTION_MAX_FAMILIES = 6;
export const NEW_ITEMS = [];
export const shortcuts = [{
  text: 'Fondos',
  path: '/fondos-inversion',
  icon: 'funds',
  show: true,
  app: 'front-products'
}, {
  text: 'Planes',
  path: '/planes-pensiones',
  icon: 'planes',
  show: true,
  app: 'front-products'
}, {
  text: 'ETFs',
  path: '/etfs',
  icon: 'etfs',
  show: true,
  app: 'front-products'
}];
export const newFamiliesLinks = [{
  type: 'brokers',
  title: 'Neobancos y brókers',
  link: '/finanzas-personales/brokers'
}, {
  type: 'cuentas',
  title: 'Cuentas remuneradas',
  link: '/finanzas-personales/cuentas'
}, {
  type: 'deposits',
  title: 'Depósitos',
  link: '/finanzas-personales/depositos'
}, {
  type: 'hipotecas',
  title: 'Hipotecas',
  link: '/finanzas-personales/hipotecas'
}, {
  type: 'seguros',
  title: 'Seguros',
  link: '/finanzas-personales/seguros'
}];
export const menu = [{
  id: 'invest',
  title: 'Invertir',
  link: null,
  app: 'front-products',
  children: [{
    id: 'families',
    entitiesType: 'productFamily',
    entitiesFilter: null,
    title: 'Productos de inversión'
  }, {
    id: 'topics',
    entitiesType: 'storefront',
    entitiesFilter: 'home-markets',
    title: 'Selección Finect'
  }, {
    id: 'new-families',
    entitiesType: 'link',
    entitiesFilter: null,
    title: 'Finanzas Personales',
    link: '/finanzas-personales'
  }, {
    id: 'markets',
    entitiesType: 'storefront',
    entitiesFilter: 'home-topics',
    title: ''
  }]
}, {
  title: 'Asesoramiento',
  link: '/asesores',
  app: 'front-advisers'
}, {
  title: 'Noticias',
  link: '/articulos-financieros/noticias',
  app: 'front-products'
}, {
  title: 'Rankings de fondos',
  link: '/fondos-inversion/categoria/todos',
  app: 'front-products'
}, {
  title: 'Comparador',
  link: '/fondos-inversion/comparador',
  app: 'front-products'
}];
export const userMenu = {
  items: [{
    icon: Settings,
    text: 'Configuración',
    href: '/usuario/configuracion#personal',
    app: 'front-users',
    lastOfGroup: true
  }, {
    icon: PieChart,
    text: 'Tus finanzas',
    href: '/tus-finanzas',
    app: 'front-products'
  }, {
    icon: Heart,
    text: 'Tus favoritos',
    href: '/tus-favoritos',
    app: 'front-products',
    lastOfGroup: true
  }, {
    icon: Activity,
    text: 'Tus temas',
    href: '/tus-temas',
    app: 'front-products',
    lastOfGroup: true
  }, {
    icon: Mail,
    text: 'Tus mensajes',
    href: '/mensajes',
    app: 'front-conversations',
    lastOfGroup: true
  }, {
    icon: User,
    text: 'Tu perfil público',
    href: _ref => {
      let {
        user
      } = _ref;
      return !(user.features || []).includes('profile') ? null : "/usuario/".concat(user.alias || '');
    },
    app: 'front-products',
    lastOfGroup: true
  }, {
    icon: Briefcase,
    text: 'Tus grupos',
    href: _ref2 => {
      let {
        user
      } = _ref2;
      return user && user.administrations.length ? "https://".concat(process.env.FINECT_ADMIN_BASEURL || 'admin.finect.com') : null;
    },
    app: 'front-admin',
    lastOfGroup: true
  }, {
    icon: Briefcase,
    text: 'Finect Asesores',
    href: _ref3 => {
      let {
        user
      } = _ref3;
      if (user.organizations.filter(_ref4 => {
        let {
          roles
        } = _ref4;
        return roles.includes('adviser');
      }).length) {
        return "https://".concat(process.env.FINECT_ADMIN_BASEURL || 'admin.finect.com');
      }
      return null;
    },
    app: 'front-admin2',
    lastOfGroup: true
  }, {
    icon: LogOut,
    text: 'Cerrar sesión',
    href: () => "".concat(getLoginBaseURL(), "/logout").concat(typeof window !== 'undefined' ? "?action=".concat(getBlobAction({
      next: window.location.href
    })) : ''),
    app: 'front-login'
  }]
};